module.exports = __webpack_public_path__ + "img/signature.4d128363.gif";